import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import MainSidebarLayout from '../layouts/main-sidebar-layout/main-sidebar-layout';
import ItemContentSidebar from './item-content-sidebar/item-content-sidebar';
import ItemDashboard from './item-dashboard/item-dashboard';
export default function MainItem() {
    return (_jsxs(MainSidebarLayout, { children: [_jsx(ItemDashboard, {}), _jsx(ItemContentSidebar, {})] }));
}
